<template>
    <b-list-group-item
        class="lista-menu"
        v-if="$temAcessoView('CRED-REL-004')"
        @click.stop="abrirModal()"
    >
        <span>RELAÇÃO DE REABERTURA DAS ENTREGAS</span>
        <filtro
            ref="filtroModal"
            perfil="uabs"
            :servicos="obterRelatoriosServicos()"
            @filtrar="obterRelatorio($event)"
        ></filtro>
    </b-list-group-item>
</template>
<script>
import download from './../../../../shared/download'
import filtro from '../../relatorios/RelacaoReaberturaEntregasFiltros'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        filtro
    },

    methods: {
        abrirModal() {
            this.$refs.filtroModal.abrir()
        },

        obterRelatorio(filtro) {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterRelatorioReaberturaEntrega(filtro).then(
                (response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Falha ao obter relatório',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            download(
                                response,
                                `Relatorio_Reabertura_Entregas.xlsx`
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterRelatoriosServicos() {
            return RelatoriosServicos
        }
    }
}
</script>
